import { gql } from '@apollo/client';
import ApolloClient from '../../ApolloClient';

const GET_PRESIGNED_URL = gql`
    mutation createFileUpload ($input:FileUploadInput!){
        createFileUpload(input:$input){
            presignedUrl,
            contentType,
            key
        }
    }
`;

export interface targetResourceResponse {
    url: string;
    key: string;
}

const requestPresignedUrl = async (contentType:string, fileName:string):Promise<targetResourceResponse> => {
    let response:targetResourceResponse = {
        url: '',
        key: '',
    };

    const variables = {
        input: {contentType, fileName}
    }

    await ApolloClient.mutate({
        mutation: GET_PRESIGNED_URL, 
        variables: variables,
        context:{
            clientName: 'LOGIN',
        }  
    }).then(r => {
        response = {
            url: r.data.createFileUpload.presignedUrl,
            key: r.data.createFileUpload.key
        }
    }).catch(e => {
        throw(e)
    })

    return response;
}

export interface UploadFileResponse {
    ok: boolean;
    status: number;
    statusText: string;
    url: string;
    key: string;
}

export const uploadFile = async (file:File):Promise<UploadFileResponse> => {
    let targetResourceResponse = await requestPresignedUrl(file.type, file.name);

    let response:UploadFileResponse = {
        ok: false,
        status: 0,
        statusText: '',
        url: '',
        key: targetResourceResponse.key,
    };
    
    await fetch(targetResourceResponse.url, {
        method: 'PUT',
        body: file,
        headers: {
            'Content-Type': file.type,
        }
    }).then( r => {
        response.ok = r.ok;
        response.status = r.status;
        response.statusText = r.statusText;
        response.url = r.url;
    }).catch(e => {
        throw(e)
    });
    return response;
};

export default uploadFile;